import { Avatar, HStack } from "@chakra-ui/react";
import { Sparkle } from "@phosphor-icons/react";
import { colors } from "../../../../theme/foundations/colors";

/**
 * 
 * @param {string?} name Set _one_ of name or user -- preferably user
 * @param {User?} user User.java via UserDto.java
 * @param {boolean} ai True for "the AI" 
 * @returns 
 */
export default function AvatarBadge({name, user, ai }) {
	if (ai) {
		// use lime on dark teal from our colors		
		return <HStack style={{
			backgroundColor: colors.darkTeal, 
			borderRadius: "50%", width: "2rem", height: "2rem", alignItems: "center", justifyContent: "center"
		}}>
			<Sparkle fill={colors.lime} />
		</HStack>
	}
	if (user?.username) {
		name = user.username;
	}
	return (
		<Avatar name={name} title={name} size="sm" />
	);
}